import Radio from './radio';
import Group from './group';
import Button from './radioButton';

Radio.Button = Button;
Radio.Group = Group;
export default Radio;



// WEBPACK FOOTER //
// ./_antd1.11.2/radio/index.jsx